import type { GameState } from "@nextgammon/shared";
import { Constants } from "@nextgammon/shared";
import { useMemo } from "react";

interface UseCanOfferDoubleParams {
  gameState: GameState | null;
  gameDetails: {
    player1Id?: string;
    player2Id?: string;
    cubeOwner?: string | null;
    pendingDoubleFrom?: string | null;
    turnCount?: number;
  } | null;
  userId: string | null;
  diceRolled: boolean;
  isAnimating: boolean;
  isLoading: boolean;
  isGameFinished: boolean;
}

export function useCanOfferDouble({
  gameState,
  gameDetails,
  userId,
  diceRolled,
  isAnimating,
  isLoading,
  isGameFinished
}: UseCanOfferDoubleParams): boolean {
  return useMemo(() => {
    if (!gameState || !gameDetails || !userId) return false;

    const turnCount = gameDetails.turnCount || 0;
    const isFirstTurn = turnCount === 0;

    if (isFirstTurn) return false;
    if (diceRolled) return false;
    if (isAnimating) return false;
    if (isLoading) return false;
    if (isGameFinished) return false;

    const isPlayerTurn =
      gameState.currentPlayerColor ===
      (userId === gameDetails.player1Id ? Constants.PLAYER_WHITE : Constants.PLAYER_BLACK);
    const noPendingDouble = !gameDetails.pendingDoubleFrom;
    const canOwnCube = !gameDetails.cubeOwner || gameDetails.cubeOwner === userId;

    return isPlayerTurn && noPendingDouble && canOwnCube;
  }, [gameState, gameDetails, userId, diceRolled, isAnimating, isLoading, isGameFinished]);
}
